module.exports = __webpack_public_path__ + "img/finance5.0ebd7f1a.png";